<template>
  <figure :class="$options.name">
    <vue-plyr :class="$options.name">
      <video v-if="player === 'local'">
        <source :src="src" type="video/mp4" />
      </video>
      <div v-if="player === 'youtube'" class="plyr__video-embed">
        <iframe
          :src="
            'https://www.youtube.com/embed/' +
              src +
              '?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1'
          "
          allowfullscreen
          allowtransparency
          allow="autoplay"
        />
      </div>
      <div v-if="player === 'vimeo'" class="plyr__video-embed">
        <iframe
          :src="
            'https://player.vimeo.com/video/' +
              src +
              '?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media'
          "
          allowfullscreen
          allowtransparency
          allow="autoplay"
        />
      </div>
    </vue-plyr>
    <figcaption :class="$options.name + '__caption'" v-if="caption">
      <p>{{ caption }}</p>
    </figcaption>
  </figure>
</template>
<script>
export default {
  name: "Video",
  props: {
    caption: { default: null },
    src: { default: "" },
    player: { default: "local" },
  },
};
</script>
<style lang="scss">
.Video video {
  height: auto;
  max-width: 100%;
  width: 100%;
}
.Video__caption {
  padding: rem(8) rem(16);
  text-align: center;
}
.plyr {
  font-family: inherit;
}
.plyr__control.plyr__tab-focus {
  box-shadow: 0 0 0 rem(5) var(--highlight);
}

.plyr--audio .plyr__control.plyr__tab-focus,
.plyr--audio .plyr__control:hover,
.plyr--audio .plyr__control[aria-expanded="true"],
.plyr--video .plyr__control.plyr__tab-focus,
.plyr--video .plyr__control:hover,
.plyr--video .plyr__control[aria-expanded="true"],
.plyr__control--overlaid,
.plyr__control--overlaid:focus,
.plyr__control--overlaid:hover,
.plyr__menu__container
  .plyr__control[role="menuitemradio"][aria-checked="true"]::before {
  background: var(--highlight);
}

.plyr--full-ui input[type="range"] {
  color: var(--highlight);
}
</style>
